<div class="admin-page animals-page">
    <div class="summary">
        <button
            type="button"
            class="sum-chip"
            [class.on]="statusFilter === 'alive'"
            (click)="setStatusFilter('alive')"
        >
            <b>{{ aliveCount }}</b>
            <span>vivos</span>
        </button>
        <button
            type="button"
            class="sum-chip baixa"
            [class.on]="statusFilter === 'baixa'"
            (click)="setStatusFilter('baixa')"
        >
            <b>{{ baixaCount }}</b>
            <span>baixas</span>
        </button>
        <button
            type="button"
            class="sum-chip"
            [class.on]="statusFilter === 'all'"
            (click)="setStatusFilter('all')"
        >
            <b>{{ aliveCount + baixaCount }}</b>
            <span>todos</span>
        </button>
        <button
            type="button"
            class="sum-chip warn"
            [class.on]="statusFilter === 'noRegister'"
            (click)="setStatusFilter('noRegister')"
            title="Vivos sem registro genealógico — ainda não enviados / sem retorno do SRG-SCL"
        >
            <b>{{ noRegisterCount }}</b>
            <span>sem registro</span>
        </button>
    </div>

    <div class="toolbar">
        <div class="search">
            <mat-icon>search</mat-icon>
            <input
                type="search"
                (input)="search($event)"
                placeholder="Nome ou registro"
                aria-label="Buscar animal"
            />
        </div>
        <span class="count"
            >{{ animalsToShow.length }}{{ totalCount ? ' / ' + totalCount : '' }}
            {{
                statusFilter === 'alive'
                    ? 'vivos'
                    : statusFilter === 'baixa'
                      ? 'baixas'
                      : statusFilter === 'noRegister'
                        ? 'sem registro'
                        : ''
            }}</span
        >
        @if (statusFilter === 'noRegister' && noRegisterCount > 0) {
        <button type="button" class="more-btn" [disabled]="bulkBusy" (click)="resendAll()">
            Reenviar todos ({{ noRegisterCount }})
        </button>
        }
        @if (bulkScanning) {
        <span class="count">Listando animais…</span>
        } @else if (bulkProgress) {
        <span class="count">Enviando {{ bulkProgress.done }} de {{ bulkProgress.total }}…</span>
        }
    </div>

    @if (isLoading) {
    <div class="state">
        <mat-spinner diameter="32"></mat-spinner>
        <span>Carregando animais…</span>
    </div>
    } @else if (hasError) {
    <div class="state error">
        <mat-icon>error_outline</mat-icon>
        <span>Não foi possível carregar os animais.</span>
    </div>
    } @else if (animalsToShow.length > 0) {
    <div class="animal-cards">
        @for (animal of animalsToShow; track animal.id || animal) {
        <article class="animal-card" [class.off]="!animal.isActive">
            <div class="card-accent"></div>
            <div class="card-body">
                <span class="code">{{ animalCode(animal) }}</span>
                @if (animalName(animal)) {
                <span class="name">{{ animalName(animal) }}</span>
                }
                @if (animal.register) {
                <span class="reg">{{ animal.register }}</span>
                }
            </div>
            @if (editingBirth === animal.id) {
            <div class="card-foot birth-edit">
                <input
                    #birth
                    type="date"
                    class="birth-input"
                    [max]="today"
                    min="1901-01-01"
                    aria-label="Data de nascimento"
                    [disabled]="savingBirth"
                    (keydown.enter)="saveBirthdate(animal, birth.value)"
                    (keydown.escape)="editingBirth = null"
                />
                <button type="button" class="ev-btn" [disabled]="savingBirth" (click)="saveBirthdate(animal, birth.value)" title="Salvar e enviar ao SRG-SCL">
                    <mat-icon>check</mat-icon>
                    <span>{{ savingBirth ? 'Salvando…' : 'Salvar' }}</span>
                </button>
                <button type="button" class="ev-btn" [disabled]="savingBirth" (click)="editingBirth = null" aria-label="Cancelar" title="Cancelar">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
            } @else {
            <div class="card-foot">
                <mat-slide-toggle
                    [checked]="animal.isActive"
                    (change)="onToggleActiveState(animal)"
                    [disabled]="updatingStatus.has(animal.id)"
                    [attr.aria-label]="animal.isActive ? 'Desativar animal' : 'Ativar animal'"
                    color="primary"
                ></mat-slide-toggle>
                @if (needsResend(animal)) {
                <button
                    type="button"
                    class="ev-btn"
                    [disabled]="resending.has(animal.id) || bulkBusy"
                    (click)="resendOne(animal)"
                    aria-label="Reenviar ao SRG-SCL"
                    title="Reenviar ao SRG-SCL"
                >
                    <mat-icon>send</mat-icon>
                    <span>{{ resending.has(animal.id) ? 'Enviando…' : 'Reenviar' }}</span>
                </button>
                } @else if (isIncomplete(animal)) {
                <button
                    type="button"
                    class="warn-tag"
                    [disabled]="bulkBusy"
                    (click)="editingBirth = animal.id"
                    title="Sem data de nascimento: informe a data para enviar ao SRG-SCL"
                >
                    <mat-icon>edit_calendar</mat-icon>
                    <span>Sem nasc.</span>
                </button>
                }
                <button
                    type="button"
                    class="ev-btn"
                    (click)="onViewEvents(animal)"
                    aria-label="Ver eventos"
                    title="Eventos"
                >
                    <mat-icon>timeline</mat-icon>
                    <span>Eventos</span>
                </button>
            </div>
            }
        </article>
        }
    </div>

    @if (isLoadingMore) {
    <div class="more-wrap">
        <mat-spinner diameter="22"></mat-spinner>
        <span class="hint-more">Carregando mais…</span>
    </div>
    } @else if (canLoadMore) {
    <div class="more-wrap">
        <button type="button" class="more-btn" (click)="loadMore()">Carregar mais</button>
    </div>
    } @else if (totalCount > 0) {
    <p class="end">
        {{ totalCount }} animal{{ totalCount === 1 ? '' : 's'
        }}{{ statusFilter === 'alive' ? ' vivo(s)' : statusFilter === 'baixa' ? ' com baixa' : '' }}
    </p>
    }
    } @else {
    <div class="state">
        <span>{{ emptyMessage }}</span>
        @if (statusFilter === 'alive' && baixaCount > 0 && !searchTerm) {
        <button type="button" mat-stroked-button color="primary" (click)="setStatusFilter('baixa')">
            Ver {{ baixaCount }} com baixa
        </button>
        }
    </div>
    }
</div>
